// facets-sunhauk.js


(function () {
  function closeOthers(opened) {
    const root = opened.closest('.sh-facets--horizontal');
    if (!root) return;

    root.querySelectorAll('details.js-filter[open]').forEach((d) => {
      if (d !== opened) d.removeAttribute('open');
    });
  }

  document.addEventListener(
    'toggle',
    (e) => {
      const details = e.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.matches('.sh-facets--horizontal details.js-filter')) return;
      if (details.open) closeOthers(details);
    },
    true
  );
})();


// ----------------------------------------------------------------------+more/-less (START)------------------------------------------------------------

(function () {
  if (window.__sunhaukMoreLessBound) return;
  window.__sunhaukMoreLessBound = true;

  function getMoreToggle(event) {
    var target = event.target;

    if (target && target.nodeType === 3) {
      target = target.parentElement;
    }

    if (!target || !target.closest) return null;

    return target.closest('[data-sh-toggle-more]');
  }

  function toggleMoreLess(toggleBtn) {
    var filterGroup = toggleBtn.closest('.sh-mobile-filter-group.is-checkbox-filter');
    if (!filterGroup) return;

    var hiddenItems = filterGroup.querySelectorAll('.sh-mobile-filter-group__item--extra');
    if (!hiddenItems.length) return;

    var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    var nextExpanded = !isExpanded;

    hiddenItems.forEach(function (item) {
      item.classList.toggle('hidden', !nextExpanded);
    });

    toggleBtn.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');

    var moreText = toggleBtn.querySelector('.sh-mobile-filter-group__toggle-more');
    var lessText = toggleBtn.querySelector('.sh-mobile-filter-group__toggle-less');

    if (moreText) {
      moreText.classList.toggle('hidden', nextExpanded);
    }

    if (lessText) {
      lessText.classList.toggle('hidden', !nextExpanded);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var toggleBtn = getMoreToggle(event);
      if (!toggleBtn) return;

      event.preventDefault();
      event.stopPropagation();

      toggleMoreLess(toggleBtn);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var toggleBtn = getMoreToggle(event);
      if (!toggleBtn) return;

      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      event.stopPropagation();

      toggleMoreLess(toggleBtn);
    },
    true
  );
})();

// -----------------------------------------------------------------+more/-less (END)----------------------------------------------------------------



// ------------------------------------------------------------Added for sort (S)------------------------------------------------------------------------
document.addEventListener('change', function (event) {
  var radio = event.target.closest('.sh-mobile-sheet-sort__radio');
  if (!radio) return;

  var form = radio.closest('form');
  if (!form) return;

  radio.dispatchEvent(new Event('input', { bubbles: true }));
});
// ------------------------------------------------------------Added for sort (E)------------------------------------------------------------------------




// ------------------------------------------------------------Mobile/iPad filter drawer drag-to-close handle (S)-----------------------------------------------------------
(function () {
  if (window.__sunhaukMobileFacetsDragBound) return;
  window.__sunhaukMobileFacetsDragBound = true;

  var activeDrag = null;
  var CLOSE_DISTANCE = 90;
  var CLOSE_VELOCITY = 0.65;

  function getHandle(event) {
    var target = event.target;

    if (target && target.nodeType === 3) {
      target = target.parentElement;
    }

    if (!target || !target.closest) return null;

    return target.closest('[data-sh-mobile-facets-drag]');
  }

  function clearDragStyles(inner) {
    if (!inner) return;

    inner.classList.remove('sh-mobile-facets-is-dragging');
    inner.classList.remove('sh-mobile-facets-is-snapping');
    inner.style.removeProperty('transform');
    inner.style.removeProperty('will-change');
  }

  function closeMobileFacets(handle, event) {
    if (!handle) return;

    var details = handle.closest('details.mobile-facets__disclosure');
    if (!details) return;

    var menuDrawer = handle.closest('menu-drawer');
    var summary = details.querySelector('summary');

    /*
      Use Dawn's native menu-drawer close method when available.
      This keeps body scroll lock, focus trap, and drawer classes correct.
    */
    if (menuDrawer && typeof menuDrawer.closeMenuDrawer === 'function') {
      menuDrawer.closeMenuDrawer(event || new Event('click'), summary || false);
      return;
    }

    /*
      Fallback for custom templates where Dawn's close method is not available.
    */
    details.classList.remove('menu-opening');
    details.removeAttribute('open');

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }

    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-mobile');
    document.body.classList.remove('overflow-hidden-tablet');
    document.documentElement.classList.remove('overflow-hidden');
  }

  function snapBack(inner) {
    if (!inner) return;

    inner.classList.remove('sh-mobile-facets-is-dragging');
    inner.classList.add('sh-mobile-facets-is-snapping');

    inner.style.setProperty('transform', 'translate3d(0, 0, 0)', 'important');

    window.setTimeout(function () {
      clearDragStyles(inner);
    }, 190);
  }

  function animateAndClose(handle, inner, event) {
    if (!inner) {
      closeMobileFacets(handle, event);
      return;
    }

    inner.classList.remove('sh-mobile-facets-is-dragging');
    inner.classList.add('sh-mobile-facets-is-snapping');

    inner.style.setProperty('transform', 'translate3d(0, 105vh, 0)', 'important');

    window.setTimeout(function () {
      closeMobileFacets(handle, event);
      clearDragStyles(inner);
    }, 180);
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var handle = getHandle(event);
      if (!handle) return;

      if (event.button != null && event.button !== 0) return;

      var details = handle.closest('details.mobile-facets__disclosure');
      if (!details || !details.open) return;

      var inner = handle.closest('.mobile-facets__inner');
      if (!inner) return;

      activeDrag = {
        handle: handle,
        inner: inner,
        pointerId: event.pointerId,
        startY: event.clientY,
        lastY: event.clientY,
        startTime: Date.now(),
        moved: false
      };

      inner.classList.add('sh-mobile-facets-is-dragging');
      inner.style.setProperty('will-change', 'transform');

      if (handle.setPointerCapture && event.pointerId != null) {
        try {
          handle.setPointerCapture(event.pointerId);
        } catch (err) {}
      }
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!activeDrag) return;

      if (
        activeDrag.pointerId != null &&
        event.pointerId != null &&
        event.pointerId !== activeDrag.pointerId
      ) {
        return;
      }

      var deltaY = event.clientY - activeDrag.startY;

      if (deltaY < 0) {
        deltaY = 0;
      }

      if (deltaY > 4) {
        activeDrag.moved = true;
        event.preventDefault();
      }

      activeDrag.lastY = event.clientY;
      activeDrag.inner.style.setProperty(
        'transform',
        'translate3d(0, ' + deltaY + 'px, 0)',
        'important'
      );
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      if (!activeDrag) return;

      if (
        activeDrag.pointerId != null &&
        event.pointerId != null &&
        event.pointerId !== activeDrag.pointerId
      ) {
        return;
      }

      var deltaY = Math.max(0, activeDrag.lastY - activeDrag.startY);
      var elapsed = Math.max(1, Date.now() - activeDrag.startTime);
      var velocity = deltaY / elapsed;

      var shouldClose = deltaY >= CLOSE_DISTANCE || velocity >= CLOSE_VELOCITY;

      if (activeDrag.moved) {
        activeDrag.handle.dataset.shDragMoved = 'true';

        window.setTimeout(function (handle) {
          if (handle) {
            delete handle.dataset.shDragMoved;
          }
        }, 350, activeDrag.handle);
      }

      if (shouldClose) {
        animateAndClose(activeDrag.handle, activeDrag.inner, event);
      } else {
        snapBack(activeDrag.inner);
      }

      activeDrag = null;
    },
    true
  );

  document.addEventListener(
    'pointercancel',
    function () {
      if (!activeDrag) return;

      snapBack(activeDrag.inner);
      activeDrag = null;
    },
    true
  );

  
  /*
    Tapping the handle also closes the drawer.
    Dragging will not accidentally trigger this because we ignore the next click after movement.
  */
  document.addEventListener(
    'click',
    function (event) {
      var handle = getHandle(event);
      if (!handle) return;

      event.preventDefault();
      event.stopPropagation();

      if (handle.dataset.shDragMoved === 'true') {
        delete handle.dataset.shDragMoved;
        return;
      }

      closeMobileFacets(handle, event);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var handle = getHandle(event);
      if (!handle) return;

      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      event.stopPropagation();

      closeMobileFacets(handle, event);
    },
    true
  );
})();
// ------------------------------------------------------------Mobile/iPad filter drawer drag-to-close handle (E)------------------------------------------------------------








/* ==========================================================================
   SUNHAUK COLLECTION STICKY FILTER — FOOTER COLLISION PROTECTION----------------------------------------------------------------------------------------------------START

   Purpose:
   - Keep the collection filter bar sticky while products are visible.
   - Hide it when the footer reaches the sticky bar.
   - Restore it automatically when scrolling back upward.
   - Prevent the filter bar from sliding over the main header.
   - Work after Shopify AJAX filtering updates the product grid.
   ========================================================================== */

(function () {
  'use strict';

  var mobileCollectionQuery = window.matchMedia('(max-width: 1200px)');
  var updateQueued = false;
  var mainObserver = null;

  /**
   * Returns the current collection sticky filter bar.
   *
   * We query it each time because Shopify facets can update
   * collection markup through AJAX.
   */
  function getStickyFilterBar() {
    return document.getElementById('main-collection-filters');
  }

  /**
   * Returns the main footer element.
   */
  function getFooter() {
    return (
      document.querySelector('footer.footer') ||
      document.querySelector('.shopify-section-group-footer-group')
    );
  }

  /**
   * Checks whether the mobile facets drawer is currently open.
   *
   * The sticky bar must not be hidden while someone is actively
   * using the filter drawer.
   */
  function isMobileFilterDrawerOpen(filterBar) {
    if (!filterBar) return false;

    return Boolean(
      filterBar.querySelector('.mobile-facets__disclosure[open]')
    );
  }

  /**
   * Reads the configured sticky top value.
   *
   * This automatically respects your existing values for:
   * - announcement bar
   * - countdown timer
   * - no top bar
   *
   * Therefore, no hard-coded top measurement is required here.
   */
  function getStickyTop(filterBar) {
    if (!filterBar) return 0;

    var computedStyle = window.getComputedStyle(filterBar);
    var stickyTop = parseFloat(computedStyle.top);

    return Number.isFinite(stickyTop) ? stickyTop : 0;
  }

  /**
   * Adds or removes the footer collision class.
   */
  function updateFooterCollision() {
    updateQueued = false;

    var filterBar = getStickyFilterBar();

    if (!filterBar) return;

    /*
     * The visual footer protection is only needed for the
     * mobile and iPad collection layout.
     */
    if (!mobileCollectionQuery.matches) {
      filterBar.classList.remove('sh-filter-footer-collision');
      return;
    }

    var footer = getFooter();

    if (!footer) {
      filterBar.classList.remove('sh-filter-footer-collision');
      return;
    }

    /*
     * Never hide the wrapper while its mobile filter drawer
     * is open.
     */
    if (isMobileFilterDrawerOpen(filterBar)) {
      filterBar.classList.remove('sh-filter-footer-collision');
      return;
    }

    var filterRect = filterBar.getBoundingClientRect();
    var footerRect = footer.getBoundingClientRect();
    var stickyTop = getStickyTop(filterBar);

    /*
     * The collision line is the bottom edge of the filter bar
     * while it is in its normal sticky position.
     */
    var collisionLine = stickyTop + filterRect.height;

    /*
     * Once the footer reaches the bottom of the sticky bar,
     * hide the bar before CSS sticky containment pushes it
     * upward over the site header.
     */
    var footerHasReachedFilter =
      footerRect.top <= collisionLine + 1;

    filterBar.classList.toggle(
      'sh-filter-footer-collision',
      footerHasReachedFilter
    );
  }

  /**
   * Throttles scroll updates to one calculation per frame.
   */
  function requestFooterCollisionUpdate() {
    if (updateQueued) return;

    updateQueued = true;

    window.requestAnimationFrame(updateFooterCollision);
  }

  /**
   * Initializes the behavior once.
   */
  function initializeStickyFooterProtection() {
    requestFooterCollisionUpdate();

    window.addEventListener(
      'scroll',
      requestFooterCollisionUpdate,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      requestFooterCollisionUpdate,
      { passive: true }
    );

    /*
     * Recalculate when switching between mobile, iPad and desktop.
     */
    if (typeof mobileCollectionQuery.addEventListener === 'function') {
      mobileCollectionQuery.addEventListener(
        'change',
        requestFooterCollisionUpdate
      );
    } else if (typeof mobileCollectionQuery.addListener === 'function') {
      /*
       * Older Safari fallback.
       */
      mobileCollectionQuery.addListener(
        requestFooterCollisionUpdate
      );
    }

    /*
     * Shopify facets replace parts of the collection through AJAX.
     * Watching MainContent ensures the footer position is recalculated
     * after filters, sorting or pagination update the product grid.
     */
    var mainContent = document.getElementById('MainContent');

    if (
      mainContent &&
      'MutationObserver' in window
    ) {
      mainObserver = new MutationObserver(function () {
        requestFooterCollisionUpdate();
      });

      mainObserver.observe(mainContent, {
        childList: true,
        subtree: true
      });
    }

    /*
     * Shopify theme editor support.
     */
    document.addEventListener(
      'shopify:section:load',
      requestFooterCollisionUpdate
    );

    document.addEventListener(
      'shopify:section:reorder',
      requestFooterCollisionUpdate
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeStickyFooterProtection,
      { once: true }
    );
  } else {
    initializeStickyFooterProtection();
  }
})();


/* ==========================================================================
   SUNHAUK COLLECTION STICKY FILTER — FOOTER COLLISION PROTECTION----------------------------------------------------------------------------------------------------END
   ========================================================================== */